import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import commomHeader from '../../assets/img/commonHeader.png'
import tiktok from '../../assets/img/tiktok.png'
import youtube from '../../assets/img/youtube.png'
import right from '../../assets/img/boosterRight.png'
import '../../css/web/UserSpBoosterPg.css'


import guidePc1 from '../../assets/img/guidePc1.png'
import guidePc2 from '../../assets/img/guidePc2.png'
import guidePc3 from '../../assets/img/guidePc3.png'
import guidePc4 from '../../assets/img/guidePc4.png'
import guidePc5 from '../../assets/img/guidePc5.png'
import guidePc6 from '../../assets/img/guidePc6.png'
import guidePc7 from '../../assets/img/guidePc7.png'
import guidePc8 from '../../assets/img/guidePc8.png'
import guidePc9 from '../../assets/img/commonDownload.png'
import guidePc10 from '../../assets/img/guidePc10.png'
import guidePc11 from '../../assets/img/guidePc11.png'

import guideOne from '../../assets/img/guideOne.png'
import guideTwo from '../../assets/img/guideTwo.png'
import guideThree from '../../assets/img/guideThree.png'
import guideFour from '../../assets/img/guideFour.png'
import guideFive from '../../assets/img/guideFive.png'
import guideSix from '../../assets/img/guideSix.png'

import boosterKrImg1 from '../../assets/img/boosterKrImg1.png'
import boosterKrImg2 from '../../assets/img/boosterKrImg2.png'
import boosterKrImg3 from '../../assets/img/boosterKrImg3.png'
import boosterKrImg4 from '../../assets/img/boosterKrImg4.png'
import boosterKrImg5 from '../../assets/img/boosterKrImg5.png'
import boosterKrImg6 from '../../assets/img/boosterKrImg6.png'
import boosterKrImg7 from '../../assets/img/boosterKrImg7.png'
import boosterKrImg8 from '../../assets/img/boosterKrImg8.png'
import boosterKrImg9 from '../../assets/img/boosterKrImg9.png'
import boosterKrImg10 from '../../assets/img/boosterKrImg10.png'

import axios from '../../services/axiosInstance';
import i18n from "../../i18n";
import {Link} from "react-router-dom";
import SeoHelmet from "../../components/SeoHelmet";
import {MdKeyboardArrowDown} from "react-icons/md";
import commonGuide from "../../assets/img/commonGuide.png";
import GuideModal from "../../components/web/modal/GuideModal";
import shBoosterCart from "../../assets/img/shBoosterCart.png";
import download from "../../assets/img/download3d.png";
import {Helmet} from "react-helmet-async";

function UserSpBoosterPg() {

    const {t} = useTranslation();

    useEffect(() => {
        selectedBoosterList();
    }, [])

    const [data, setData] = useState([]);
    const selectedBoosterList = () => {
        axios({
            method: 'get',
            url: '/shopping/booster/selectedBoosterList',
        })
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                console.log("조회실패 : ", error)
            });
    };

    const moveToYoutubeLink = () => {
        const lang = i18n.language || 'ko'
        if (lang === 'en') {
            window.open('https://www.youtube.com/watch?v=fjkCPdcyRCk', "_blank");
        } else if (lang === 'ja') {
            window.open('https://www.youtube.com/watch?v=11B7p_oOays', "_blank");
        } else if (lang === 'zh') {
            window.open('https://www.youtube.com/watch?v=HOkUX_aDsy0', "_blank");
        } else if (lang === 'id') {
            window.open('https://www.youtube.com/watch?v=SKpWX78VEE0&feature=youtu.be', "_blank");
        } else {
            window.open('https://www.youtube.com/watch?v=OaN8c0VBQOE', "_blank");
        }
    }

    const moveToTiktokLink = () => {
        const lang = i18n.language || 'ko'
        if (lang === 'en') {
            window.open('https://www.tiktok.com/@btorag_e/video/7494798757607804177', "_blank");
        } else if (lang === 'ja') {
            window.open('https://www.tiktok.com/@btorag_e/video/7494798944942230801', "_blank");
        } else if (lang === 'zh') {
            window.open('https://www.tiktok.com/@btorag_e/video/7494799130796002577', "_blank");
        } else if (lang === 'id') {
            window.open('https://www.tiktok.com/@btorag_e/video/7494799409159359745', "_blank");
        } else {
            window.open('https://www.tiktok.com/@btorag_e/video/7494796087253863697', "_blank");
        }
    }

    const [guideTab, setGuideTab] = useState(true);
    const [storeTab, setStoreTab] = useState(false);
    const handleMainTab = ((tab) => {
        if (tab === "guide") {
            setGuideTab(true);
            setStoreTab(false);
        } else {
            setGuideTab(false);
            setStoreTab(true);
        }
    })

    const [searchInput, setSearchInput] = useState("");
    const handleSearchInput = (e) => {
        setSearchInput(e);
    }

    const [displayLimit, setDisplayLimit] = useState(50);
    const filteredData = data.filter(item =>
        item.shopNm?.toLowerCase().includes(searchInput.toLowerCase()) ||
        item.shopUrl?.toLowerCase().includes(searchInput.toLowerCase()) ||
        item.url?.toLowerCase().includes(searchInput.toLowerCase())
    );

    const loadMoreData = () => {
        setDisplayLimit(prev => prev + 50);
    };

    const displayedData = filteredData.slice(0, displayLimit);

    const boosterGuideHeader = t('sbpTx3')
    const boosterGuideContent = t('sbpTx4')

    const [boosterGuidePopupShow, setBoosterGuidePopupShow] = useState(false);
    const openBoosterGuidePopup = (() => {
        setBoosterGuidePopupShow(true);
    })
    const closeBoosterGuidePopup = (() => {
        setBoosterGuidePopupShow(false);
    })

    const boosterUrl = "https://chromewebstore.google.com/detail/btorage-shopping-booster/lccdehinpcindkhhengmoelpfpoldfhp?hl=ko"

    const toExternalUrl = (url) => {
        if (!url) return '#';
        const s = String(url).trim();

        if (/^javascript:/i.test(s)) return '#'; // 보안
        if (/^https?:\/\//i.test(s) || /^\/\//.test(s)) return s; // 이미 프로토콜 있음

        return `https://${s}`; // 없으면 https 붙여줌
    };

    return (
        <div className="font-t-cont">

            <Helmet>
                <title>웹쇼핑부스터</title>
                <meta name="description" content="웹프로그램으로 주문서를 입력없이 자동으로 작성하세요"/>
                <link rel="canonical" href="https://btorage.com/UserUsageGuidePg"/>
            </Helmet>

            <div
                style={{display: "flex", alignItems: "flex-start", justifyContent: "space-between", padding: "10px 0"}}>
                <div className="user-center">
                    <img className="wd-25 ht-25" src={commomHeader} alt="header"/>
                    <p className="font-s-20 font-t-title font-c-default"
                       style={{margin: "5px 0 0 10px"}}>{t(`hdSMenu10`)}</p>
                </div>
                <div>
                    <img onClick={() => window.open(boosterUrl, "_blank")} className="wd-50 ht-50 c-point"
                         src={download} alt="Tiktok"/>
                    <img onClick={moveToYoutubeLink} className="wd-40 ht-40 m-l-5 c-point" style={{opacity: 0.6}}
                         src={youtube} alt="Tiktok"/>
                    <img onClick={moveToTiktokLink} className="wd-40 ht-40 m-l-10 c-point" style={{opacity: 0.6}}
                         src={tiktok} alt="Youtube"/>
                </div>
            </div>

            {/*가이드/스토어 탭*/}
            <div className="display-flex just-cont-sb align-center m-t-50">
                <div className="user-center wd-100pc">
                    <button
                        onClick={() => handleMainTab('guide')}
                        className={`sp-tab-btn ${guideTab ? 'active' : ''}`}
                    >
                        <p>Guide</p>
                    </button>

                    <button
                        onClick={() => handleMainTab('store')}
                        className={`sp-tab-btn ${storeTab ? 'active' : ''}`}
                        style={{marginLeft: "10px"}}
                    >
                        <p>Support Store</p>
                    </button>
                </div>
            </div>

            <div className="display-flex just-cont-sb align-center m-t-50">

                {guideTab ?
                    // 가이드탭
                    <div className="wd-100pc text-center">
                        <div className="user-center ht-100 m-t-50" style={{borderBottom: "solid 1px #EAEAEA"}}>
                            <div className="user-center">
                                <p className="font-s-25 font-t-title">{t('sbpTx5')}</p>
                                <img onClick={openBoosterGuidePopup} className="wd-30 ht-30 m-l-10 c-point m-b-5"
                                     src={commonGuide} alt="guide"/>
                                <p className="font-t-cont font-s-13 m-l-3">({t('ugCont14')})</p>
                            </div>
                        </div>
                        <div className="font-t-cont" style={{
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "40px",
                            borderBottom: "solid",
                            borderWidth: "thin 1px",
                            borderColor: "#EAEAEA"
                        }}>
                            {/*절차1*/}
                            <div>
                                <div style={{width: "150px", minHeight: "150px"}}>
                                    <div className="user-center" style={{height: "90px", position: "relative"}}>
                                        <img style={{
                                            width: "22px",
                                            height: "22px",
                                            position: "absolute",
                                            top: "5px",
                                            left: "20px",
                                            opacity: "0.6",
                                            filter: "grayscale(100%) brightness(99%)"
                                        }} src={guideOne} alt="one"/>
                                        <img style={{width: "60px", height: "60px", opacity: "0.7"}} src={guidePc9}
                                             alt="process2"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{
                                            margin: "0",
                                            fontSize: "14px",
                                            color: "black",
                                            textAlign: "center"
                                        }}>{t('sbpTx6')}</p>
                                    </div>
                                </div>
                            </div>

                            {/*절차2*/}
                            <div>
                                <div style={{width: "150px", minHeight: "150px"}}>
                                    <div className="user-center" style={{height: "90px", position: "relative"}}>
                                        <img style={{
                                            width: "22px",
                                            height: "22px",
                                            position: "absolute",
                                            top: "5px",
                                            left: "20px",
                                            opacity: "0.6",
                                            filter: "grayscale(100%) brightness(99%)"
                                        }} src={guideTwo} alt="one"/>
                                        <img style={{width: "60px", height: "60px", opacity: "0.7"}} src={guidePc10}
                                             alt="process2"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{
                                            margin: "0",
                                            fontSize: "14px",
                                            color: "black",
                                            textAlign: "center"
                                        }}>{t('sbpTx7')}</p>
                                    </div>
                                </div>
                            </div>

                            {/*절차3*/}
                            <div>
                                <div style={{width: "150px", minHeight: "150px"}}>
                                    <div className="user-center" style={{height: "90px", position: "relative"}}>
                                        <img style={{
                                            width: "22px",
                                            height: "22px",
                                            position: "absolute",
                                            top: "5px",
                                            left: "20px",
                                            opacity: "0.6",
                                            filter: "grayscale(100%) brightness(99%)"
                                        }} src={guideThree} alt="one"/>
                                        <img style={{width: "60px", height: "60px", opacity: "0.7"}} src={guidePc11}
                                             alt="process2"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{
                                            margin: "0",
                                            fontSize: "14px",
                                            color: "black",
                                            textAlign: "center"
                                        }}>{t('sbpTx8')}</p>
                                    </div>
                                </div>
                            </div>

                            {/*절차4*/}
                            <div>
                                <div style={{width: "150px", minHeight: "150px"}}>
                                    <div className="user-center" style={{height: "90px", position: "relative"}}>
                                        <img style={{
                                            width: "22px",
                                            height: "22px",
                                            position: "absolute",
                                            top: "5px",
                                            left: "20px",
                                            opacity: "0.6",
                                            filter: "grayscale(100%) brightness(99%)"
                                        }} src={guideFour} alt="one"/>
                                        <img style={{width: "60px", height: "60px", opacity: "0.7"}} src={guidePc3}
                                             alt="process2"/>
                                    </div>
                                    <div className="user-center">
                                        <p style={{
                                            margin: "0",
                                            fontSize: "14px",
                                            color: "black",
                                            textAlign: "center"
                                        }}>{t('sbpTx9')}</p>
                                    </div>
                                </div>
                            </div>

                        </div>


                        {/*부스터가이드 사진영역 내용1*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "5px 10px"
                                    }}>1</span>
                                    <p className="font-s-21 m-l-10" style={{textDecoration: "underline", textAlign:"start"}}>{t('sbpTx10')}</p>
                                </div>

                                {/*바디*/}
                                <div style={{marginTop: "20px", textAlign: "left",}}>
                                    <p className="font-s-15">
                                        <span>※ {t('sbpTx11')} </span>
                                        <span onClick={() => window.open(boosterUrl, "_blank")}
                                              style={{color: "#4B89DC", cursor:"pointer"}}>[{t('sbpTx12')}]</span>{t('sbpTx13')}
                                    </p>
                                </div>

                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-100pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg2}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                        {/*부스터가이드 사진영역 내용2*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "5px 10px"
                                    }}>2</span>
                                    <p className="font-s-21 m-l-10" style={{textDecoration: "underline", textAlign:"start"}}>{t('sbpTx14')}</p>
                                </div>

                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-100pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg3}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                        {/*부스터가이드 사진영역 내용3*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "5px 10px"
                                    }}>3</span>
                                    <p className="font-s-21 m-l-10"
                                       style={{textDecoration: "underline", textAlign: "start"}}>
                                        {t('sbpTx15')}
                                    </p>
                                </div>

                                {/*바디*/}
                                <div style={{marginTop: "20px", textAlign: "left"}}>
                                    <p className="font-s-15">※ {t('sbpTx16')}</p>
                                    <p className="font-s-15">※ {t('sbpTx17')}</p>
                                    <p className="font-s-15">※ {t('sbpTx18')}</p>
                                </div>


                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-100pc pd10" style={{
                                        border: "solid",
                                        borderWidth: "5px",
                                        borderRadius: "20px",
                                        borderColor: "#EAEAEA"
                                    }}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg4}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                        {/*부스터가이드 사진영역 내용4*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "4px 11px"
                                    }}>4</span>
                                    <p className="font-s-21 m-l-10" style={{textDecoration: "underline", textAlign:"start"}}>
                                        {t('sbpTx19')}
                                    </p>
                                </div>

                                {/*바디*/}
                                <div style={{marginTop: "20px", textAlign: "left",}}>
                                    <p className="font-s-15">
                                        ※ {t('sbpTx20')}
                                    </p>
                                </div>

                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-45pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg5}

                                        />
                                    </div>
                                    <div className="wd-10pc">
                                        <img className="wd80 ht-40" src={right} alt="right"/>
                                    </div>
                                    <div className="wd-45pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg6}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                        {/*부스터가이드 사진영역 내용5*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "5px 10px"
                                    }}>5</span>
                                    <p className="font-s-21 m-l-10" style={{textDecoration: "underline", textAlign:"start"}}>
                                        {t('sbpTx22')}
                                    </p>
                                </div>

                                {/*바디*/}
                                <div style={{marginTop: "20px", textAlign: "left",}}>
                                    <p className="font-s-15">
                                        Tip. {t('sbpTx23')}
                                    </p>
                                </div>

                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-100pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg7}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                        {/*부스터가이드 사진영역 내용6*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "4px 11px"
                                    }}>6</span>
                                    <p className="font-s-21 m-l-10" style={{textDecoration: "underline", textAlign:"start"}}>
                                        {t('sbpTx24')}
                                    </p>
                                </div>

                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems:"flex-start",
                                    justifyContent: "space-between",
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-45pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg8}

                                        />
                                    </div>
                                    <div className="wd-10pc" style={{marginTop:"20%"}}>
                                        <img className="wd80 ht-40" src={right} alt="right"/>
                                    </div>
                                    <div className="wd-45pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg9}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                        {/*부스터가이드 사진영역 내용7*/}
                        <div className="m-t-50 wd-100pc pd20">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center"
                            }}>
                                {/*헤더*/}
                                <div className="user-center">
                                    <span className="wd-30 ht-30" style={{
                                        backgroundColor: "lightgray",
                                        color: "white",
                                        borderRadius: "6px",
                                        padding: "5px 10px"
                                    }}>7</span>
                                    <p className="font-s-21 m-l-10" style={{textDecoration: "underline", textAlign:"start"}}>
                                        {t('sbpTx25')}
                                    </p>
                                </div>

                                <div className="m-t-30" style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding:"0 200px"
                                }}>
                                    {/*푸터(이미지)*/}
                                    <div className="wd-100pc pd10" style={{border:"solid", borderWidth:"5px", borderRadius:"20px", borderColor:"#EAEAEA"}}>
                                        <img
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            alt="Booster Guide Image"
                                            src={boosterKrImg10}

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>




                    </div>
                    :
                    storeTab ?
                        // 스토어탭
                        <div style={{width: "100%", padding: "20px"}}>
                            {/* 🔍 검색 인풋 */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '30px'
                            }}
                            >

                                <input className="sp-store-tab-search-input"
                                       type="text"
                                       maxLength={30}
                                       placeholder={t('sbpTx26')} value={searchInput}
                                       onChange={(e) => handleSearchInput(e.target.value)}/>
                            </div>

                            {/* 🛒 쇼핑몰 리스트 */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '15px',
                                justifyContent: 'center'
                            }}>
                                {displayedData.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={() => window.open(toExternalUrl(item.shopUrl), "_blank", "noopener,noreferrer")}
                                        style={{
                                            display:"flex",
                                            alignItems:"center",
                                            justifyContent:"center",
                                            flex: "0 0 calc(10% - 15px)", // 한 줄에 10개 (gap 포함)
                                            textAlign: 'center',
                                            padding: '12px 8px',
                                            background: '#fff',
                                            borderRadius: '12px',
                                            border: '1px solid #eee',
                                            cursor: 'pointer',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                            transition: 'all 0.3s ease-in-out',
                                            fontSize: '13px',
                                            color: '#A8A8A8'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "scale(1.05)";
                                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "scale(1)";
                                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)";
                                        }}
                                    >
                                        {item.shopNm}
                                    </div>
                                ))}
                            </div>

                            {filteredData.length > displayLimit && (
                                // 더보기버튼
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '40px'
                                }}>
                                    <button
                                        onClick={loadMoreData}
                                        style={{
                                            backgroundColor: '#C5C5C5',
                                            color: 'white',
                                            padding: '12px 24px',
                                            border: 'none',
                                            borderRadius: '25px',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            cursor: 'pointer',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                            transition: 'all 0.2s ease-in-out'
                                        }}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'darkgray'}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#C5C5C5'}
                                    >
                                        More
                                    </button>
                                </div>
                            )}

                        </div>
                        :
                        null
                }


            </div>

            {
                boosterGuidePopupShow ?
                    <GuideModal boosterGuidePopupShow={boosterGuidePopupShow}
                                closeBoosterGuidePopup={closeBoosterGuidePopup}
                                boosterGuideHeader={boosterGuideHeader} boosterGuideContent={boosterGuideContent}/>
                    :
                    null
            }

        </div>
    )
}

export default UserSpBoosterPg
